import type { FC, PropsWithChildren } from 'react';

import './styles/ListContainer.scss';

const ListContainer: FC<PropsWithChildren> = ({ children }) => <div className='ListContainer'>{children}</div>;

export default ListContainer;
